/******************************************************************************************
 *	Regions Service
 ********************************************************************************************/
(function() {
  

  angular.module('rcServices.regions', []).service(
    'Regions',
    /* @ngInject */
    function(_, $http, $q, DefaultResponseTransformer, DemoMode, RegionList, Settings) {
      this.get = function(countryCode) {
        const deferred = $q.defer();
        if (DemoMode.isEnabled()) {
          $http({
            method: 'GET',
            url: '/demo-data/' + _.toLower(countryCode) + '-regions.json'
          })
            .then(response => {
              const regions = _.get(response, 'data.regions', []);
              addDefaultRegion(regions);
              deferred.resolve(_.orderBy(regions, ['regionName']));
            })
            .catch(() => {
              const regions = [];
              addDefaultRegion(regions);
              deferred.resolve(_.orderBy(regions, ['regionName']));
            });
        } else {
          RegionList.get({countryCode})
            .$promise.then(function(regionList) {
              const regions = regionList.items;
              addDefaultRegion(regions);
              deferred.resolve(_.orderBy(regions, ['regionName']));
            })
            .catch(deferred.reject);
        }
        return deferred.promise;

        function addDefaultRegion(regions) {
          // Always add a default region. It should get sorted to the bottom of the list
          // because it doesn't have a regionName value.
          const defaultRegion = {
            regionCode: Settings.DEFAULT_REGION_CODE,
            regionNameKey: 'generic.defaultRegion'
          };
          regions.push(defaultRegion);
        }
      };
    }
  );
})();
